/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates a filters sort by drop down
 *
 * Usage example:
 * <filters-sort-by
 *     data-on-sort-option-selected="FavProductsCtrl.sortOptionSelected(selectedSortOption)"
 *     data-selected-code="FavProductsCtrl.selectedSortByCode">
 * </filters-sort-by>
 *
 * FavProductsCtrl.sortOptionSelected method example:
 * vm.sortOptionSelected = function(selectedSortOption) {
 *     alert(selectedSortOption.display_name);
 * }
 */
function filtersSortByDirective() {

    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        scope: {
            isResultsPage: '@',
            isFavoritedProductsPage: '@',
            onSortOptionSelected: '&'
        },
        controller: filtersSortByController,
        template: require('./filtersSortByView.html')
    };
}

filtersSortByController.$inject = [
    '$scope',
    '$filter',
    'FiltersSortByService'
];
function filtersSortByController(
    $scope,
    $filter,
    FiltersSortByService
) {

    var _filtersSortByOptionsByCode;

    setupSortByDropDown();
    FiltersSortByService.onSetActiveSortByOption(() => {
        setupSortByDropDown();
    });

    /**
     * Gets the initial sort by data
     *
     */
    var postProcessSortByFilters = function(){
        _filtersSortByOptionsByCode = FiltersSortByService.getFiltersSortByOptionsByCode();
        var defaultOption = FiltersSortByService.getActiveSortByOption();
        $scope.selectedFiltersSortByOption = _filtersSortByOptionsByCode[defaultOption];
    };

    /**
     * Sets up the the sort by dropdown
     *
     */
    function setupSortByDropDown() {
        FiltersSortByService.updateActiveSortOptions($scope.isFavoritedProductsPage).then(function() {
            FiltersSortByService.getFiltersSortByOptions().then(function(result) {
                $scope.filtersSortByOptions = result;
                postProcessSortByFilters();
                FiltersSortByService.isSortByDropdownReady = true;
            });
        });
    }

    /**
     * Gets the selected sort by option and calls the onSortOptionSelected call back
     * and passes the selected option in it
     *
     * @param {String} rawCode - The untranslated code for the sort option
     */
    $scope.filterSortBySelected = function (rawCode) {
        FiltersSortByService.trackProductSortEngaged(rawCode);
        $scope.selectedFiltersSortByOption = _filtersSortByOptionsByCode[rawCode];
        $scope.onSortOptionSelected({'selectedSortOption': $scope.selectedFiltersSortByOption});
    };

    /**
     * Determines whether or not the sort by dropdown is ready
     * @returns {boolean}
     */
    $scope.isSortByDropdownReady = () => {
        return FiltersSortByService.isSortByDropdownReady;
    };
}

module.exports = filtersSortByDirective;
